import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { ActionService } from 'src/app/services/actions/action.service';
import { AlertService, MessageSeverity } from 'src/app/services/alert.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { DeleteClassificationRequest, DeleteClassificationResponse, GetClassificationRequest, GetClassificationResponse, SaveClassificationRequest, SaveClassificationResponse } from 'src/app/services/document-type/document-type-plugin-models';
import { DocumentTypeDocumentClassification } from 'src/app/services/document-type/document-type.model';
import { DocumentTypeBaseComponent } from '../../document-types-base.component';

@Component({
    selector: 'app-doctype-class',
    templateUrl: './doc-class.component.html',
    styleUrls: ['./doc-class.component.scss']
})
export class DocumentTypeDocClassComponent extends DocumentTypeBaseComponent implements OnChanges {

    constructor(
        private alertService: AlertService,
        private confirmationService: ConfirmationService,
        public actionService: ActionService,
        public configurationService: ConfigurationService

    ) {
        super(configurationService, actionService);
    }

    documentClassification: DocumentTypeDocumentClassification = new DocumentTypeDocumentClassification();
    initialDocumentClassification: DocumentTypeDocumentClassification

    @Input() documentTypeId: number;
    @Input() active: boolean = false;

    @ViewChild('documentClassificationForm', { static: false }) documentClassificationForm: NgForm;

    async ngOnChanges(changes: SimpleChanges) {
        if (changes.documentTypeId?.currentValue) {
            this.documentClassification = await this.getDocumentClassificationConfig(+changes.documentTypeId?.currentValue);
            this.setInitialClassification();
        }
    }

    async saveChanges(event) {
        try {
            const saveResponse = await this.saveDocumentClassificationConfig(this.documentTypeId, this.documentClassification);

            if (saveResponse.statusCode === 200) {
                this.setInitialClassification();
                this.documentClassificationForm.form.markAsPristine();

                this.alertService.showMessage('Classification settings saved.', null, MessageSeverity.success);
            } else {
                this.alertService.showMessage('Failed to save classification settings.', 'Unknown error ocurred during the classification configuration save.', MessageSeverity.error);
            }

        } catch (error) {
            this.alertService.showMessage('Failed to save classification settings.', error.error.Message, MessageSeverity.error);
        }
    }

    resetForm() {
        this.documentClassificationForm.resetForm({
            scanningVisible: this.initialDocumentClassification?.scanning?.visible,
            uploadVisible: this.initialDocumentClassification?.upload?.visible
        });
    }

    async deleteClassification() {

        const msg = `Are you sure you want to delete this classification configuration?`;

        this.confirmationService.confirm({
            key: 'ClassificationdDeleteDialog',
            message: msg,
            accept: async () => {
                try {
                    const deleteResponse = await this.deleteDocumentClassificationConfig(this.documentTypeId);

                    if (deleteResponse.statusCode === 200) {
                        this.documentClassification = new DocumentTypeDocumentClassification();
                        this.alertService.showMessage('Document classification configuration deleted', null, MessageSeverity.success);
                    } else {
                        this.alertService.showMessage(`Failed to delete document classification configuration`, 'Unknown error ocurred during the deletion of classification configuration.', MessageSeverity.error);
                    }
                } catch (error) {
                    this.alertService.showMessage(`Failed to document classification configuration`, error.error.Message, MessageSeverity.error);
                }
            },
            reject: () => {
                return;
            }
        });
    }

    clearClassification() {
        this.documentClassification = new DocumentTypeDocumentClassification();
    }

    private async getDocumentClassificationConfig(documentTypeId: number): Promise<DocumentTypeDocumentClassification> {
        const request = new GetClassificationRequest(documentTypeId);
        let response = await this.actionService.invoke(this.ActionType, "classification-get", request) as GetClassificationResponse;
        return response.classification ?? new DocumentTypeDocumentClassification();
    }

    private async saveDocumentClassificationConfig(documentTypeId: number, docClassConfig: DocumentTypeDocumentClassification): Promise<SaveClassificationResponse> {
        const request = new SaveClassificationRequest(documentTypeId, docClassConfig);
        let response = await this.actionService.invoke(this.ActionType, "classification-save", request) as SaveClassificationResponse;
        return response;
    }

    private async deleteDocumentClassificationConfig(documentTypeId: number): Promise<DeleteClassificationResponse> {
        const request = new DeleteClassificationRequest(documentTypeId);
        let response = await this.actionService.invoke(this.ActionType, "classification-delete", request) as DeleteClassificationResponse;
        return response;
    }

    private setInitialClassification() {
        this.initialDocumentClassification = JSON.parse(JSON.stringify(this.documentClassification));
    }
}
